// extracted by mini-css-extract-plugin
export default {"container":"CompetitorPriceOfferCell_container__FnXxP","competitor":"CompetitorPriceOfferCell_competitor__ZOtU-"};